import CoursesRoutes from '@/pages/admin/components/course/router';
import UsersRoutes from '@/pages/admin/components/user/router';
import MachinesRoutes from '@/pages/admin/components/machine/router';

export default [
  {
    path: 'admin',
    component: () => import('@/pages/admin/Admin'),
    meta: {
      requiresAuth: true,
      role: 'admin',
    },
    children: [
      {
        path: '',
        redirect: 'courses',
      },
      ...CoursesRoutes,
      ...UsersRoutes,
      ...MachinesRoutes,
    ]
  },
];
